@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let isReported = shift().state | isShiftSubmittedOrAccepted;
@let isAccepted = shift().state | isShiftAccepted;

@if (isReported) {
  <section class="drawer-section drawer-section--separated">
    <nz-collapse
      [nzBordered]="false"
      nzGhost
      data-test-id="wilson-shift-reported-section:reported-collapse"
    >
      <nz-collapse-panel
        class="collapse-panel"
        [nzHeader]="'page.simplified_shift_drawer.report' | translate"
        [nzActive]="isExpandedOnOpen()"
      >
        <wilson-collapsible-activities-list
          [shift]="shift()"
          [collapsible]="false"
          (refreshTableDataAndUpdateShiftPublication)="refresh.emit()"
        ></wilson-collapsible-activities-list>

        <wilson-shift-violation-comment
          [shiftId]="shift().id"
        ></wilson-shift-violation-comment>

        @if ('approved-time-report-attachments' | featureFlagPure | async) {
          <wilson-collapsible-shift-reports-attachments
            [selectedShift]="shift()"
            [collapsible]="false"
            (refresh)="refresh.emit()"
          ></wilson-collapsible-shift-reports-attachments>
        }

        @if (FeatureName.Payroll | featurePure | async) {
          @if (isAccepted) {
            <wilson-payroll-transactions
              [userId]="shift().userId ?? undefined"
              [shiftId]="shift().id"
              [shiftDate]="shift().startDate"
              [shiftState]="shift().state"
              [collapsible]="false"
              (refresh)="refresh.emit()"
            ></wilson-payroll-transactions>
          }
          <wilson-collapsible-shift-wage-data
            [shift]="shift()"
            [collapsible]="false"
            [areInputsDisabled]="isAccepted"
          ></wilson-collapsible-shift-wage-data>
          @if (hasShiftUpdatePermission) {
            <wilson-collapsible-shift-note
              [shiftId]="shift().id"
              [collapsible]="false"
              [payrollInformation]="shift().payrollInformation ?? null"
              (refresh)="refresh.emit()"
            ></wilson-collapsible-shift-note>
          }
        }
      </nz-collapse-panel>
    </nz-collapse>
  </section>
}
